module.exports = __webpack_public_path__ + "img/46.507c7cd3.svg";